import { Activity, Operation } from "@cloudserver/contracts";
import { useQuery } from "@tanstack/react-query";
import { z } from "zod";
import { api } from "./client.js";

/**
 * Changes still running in the project, so lists and detail pages show
 * progress; refreshed with every live update like all project queries.
 */
export const useRunningOperations = (projectId: string, enabled = true) =>
  useQuery({
    queryKey: ["projects", projectId, "operations", "running"],
    queryFn: () =>
      api(`/projects/${projectId}/operations?status=running`, { schema: z.array(Operation) }),
    enabled,
  });

/** Progress of a running change on one resource, or null. */
export function progressOf(operations: Operation[] | undefined, resourceId: string): number | null {
  const running = operations?.find((o) => o.resources.some((r) => r.id === resourceId));
  return running ? running.progress : null;
}

/** The project's latest activities (the overview feed). */
export const useProjectActivities = (projectId: string, limit = 10) =>
  useQuery({
    queryKey: ["projects", projectId, "activities", "latest", limit],
    queryFn: () =>
      api(`/projects/${projectId}/activities?limit=${limit}`, { schema: z.array(Activity) }),
  });
